/**
 * Open mega-nav dropdowns on hover for every top-level item, not only the
 * currently-active one. Adds Bootstrap's `.show` class to both the trigger
 * item and the panel on mouseenter, and clears it after a short grace period
 * on mouseleave so the user can move into the panel without it snapping shut.
 */

const CLOSE_DELAY_MS = 120;

export function initNavHover(): void {
    const nav = document.getElementById('mainnav');
    if (!nav) return;

    const items = nav.querySelectorAll<HTMLElement>('.nav-item.has-subs');
    items.forEach(setupItem);
}

function setupItem(item: HTMLElement): void {
    const link = item.querySelector<HTMLElement>('.nav-link-1');
    const panel = item.querySelector<HTMLElement>('.nav-level-2');
    if (!panel) return;

    let closeTimer: number | undefined;

    const open = () => {
        if (closeTimer !== undefined) {
            window.clearTimeout(closeTimer);
            closeTimer = undefined;
        }
        item.classList.add('show', 'is-hover-open');
        panel.classList.add('show');
        document.body.classList.add('nav-backdrop-open');
        link?.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = () => {
        closeTimer = window.setTimeout(() => {
            item.classList.remove('show', 'is-hover-open');
            panel.classList.remove('show');
            link?.setAttribute('aria-expanded', 'false');
            // Only drop the body class once no nav item is open
            const navRoot = document.getElementById('mainnav');
            const stillOpen = navRoot?.querySelector('.nav-item.is-hover-open, .nav-item.show');
            if (!stillOpen) {
                document.body.classList.remove('nav-backdrop-open');
            }
        }, CLOSE_DELAY_MS);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (event) => {
        const next = event.relatedTarget as Node | null;
        if (!next || !item.contains(next)) scheduleClose();
    });
}
